export const SET_ADDRESS = 'avcheck/SET_ADDRESS';
export const SET_PAGE_VALUE = 'avcheck/SET_PAGE_VALUE';
export const SET_RESULT = 'avcheck/SET_RESULT';
export const SET_RESULT_ERROR = 'avcheck/SET_RESULT_ERROR';
export const SET_CURRENT_TARGET_GROUP = 'avcheck/SET_CURRENT_TARGET_GROUP';
export const SET_CURRENT_CONTRACT_DURATION = 'avcheck/SET_CURRENT_CONTRACT_DURATION';
export const SET_SPECIAL_RESERVATIONS = 'avcheck/SET_SPECIAL_RESERVATIONS';
export const SET_CITY_LIST = 'avcheck/SET_CITY_LIST';
export const SET_STREET_LIST = 'avcheck/SET_STREET_LIST';
export const SET_HOUSEHOLD_CONFIG = 'avcheck/SET_HOUSEHOLD_CONFIG';
export const SET_TRACKING_INFO = 'avcheck/SET_TRACKING_INFO';
